/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";

import { Row, Col, Form, Button, Table } from "react-bootstrap";

import NumericEditor from "../../components/atoms/NumericEditor";
import NumericControl from "../../components/molecules/NumericControl";
import ProvinceControl from "../../components/molecules/ProvinceControl";
import FrequencyControl from "../../components/molecules/FrequencyControl";

import getPCPUrl from "../../components/pcpUrl";
import { useUnsecurePost } from "../../components/fetchHook";


export default function CanadaPayrollCalc(props) {
  const { postData, response, isLoading, error } = useUnsecurePost();
  const [province, setProvince] = useState("NS");
  const [frequency, setFrequency] = useState("26");
  const [isSalary, setIsSalary] = useState(true);
  const [salary, setSalary] = useState("50000");
  const [regHours, setRegHours] = useState("80");
  const [otHours, setOtHours] = useState("0");
  const [dtHours, setDtHours] = useState("0");
  const [rate, setRate] = useState("12.5");

  const [data, setData] = useState({ paystubs: [] });


  useEffect(() => {
    if (response === null) {
      return;
    }

    setData(response)
  }, [response]);


  function safeParseFloat(val) {
    var v = parseFloat(val);
    if (isNaN(v)) {
      return 0;
    }

    return v;
  }


  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isLoading === true) {
      return;
    }

    var payroll = {
      periods: []
    };

    var stub = {
      taxYear: 2022,

      isSalary: isSalary,  // True is salary false if hourly

      province: province,
      frequency: parseInt(frequency),
      salary: safeParseFloat(salary),
      hourlyRate: safeParseFloat(rate),
      hoursWorked: safeParseFloat(regHours),
      otWorked: safeParseFloat(otHours),
      dtWorked: safeParseFloat(dtHours),

      rrsp: 0
    }

    payroll.periods.push(stub);


    let url = getPCPUrl() + "calculators/canadapay";
    await postData(url, JSON.stringify(payroll));
  }


  function onTypeChange(event) {
    event.preventDefault();

    setIsSalary(!isSalary);
  }


  const div_style = {
    "fontSize": "0.8em"
  };

  return (
    <Row style={div_style}>

      <Col lg={{ span: 6, offset: 3 }}>

        <Form>
          <Row>
            <ProvinceControl as={Col} label="Province" value={province} onChange={setProvince} />

            <FrequencyControl as={Col} label="Frequency" value={frequency} onChange={setFrequency} />
          </Row>

          <Row>
            <Col>
              <Button onClick={onTypeChange}>{isSalary ? "I Am Hourly" : "I am Salary"}</Button>
            </Col>
          </Row>

          {isSalary &&
            <NumericControl label="Yearly Salary" value={salary} onChange={setSalary} />
          }

          {!isSalary &&
            <React.Fragment>

              <Form.Group as={Row}>
                <Form.Label column xs={6} sm={4}>
                  Rate
                </Form.Label>
                <Col xs={6} sm={6}>
                  <NumericEditor value={rate} onChange={setRate} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column xs={6} sm={4}>
                  Regular Hours
                </Form.Label>
                <Col xs={6} sm={6}>
                  <NumericEditor value={regHours} onChange={setRegHours} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column xs={6} sm={4}>
                  Overtime Hours
                </Form.Label>
                <Col xs={6} sm={6}>
                  <NumericEditor value={otHours} onChange={setOtHours} />
                </Col>
              </Form.Group>

              <Form.Group as={Row}>
                <Form.Label column xs={6} sm={4}>
                  Doubletime Hours
                </Form.Label>
                <Col xs={6} sm={6}>
                  <NumericEditor value={dtHours} onChange={setDtHours} />
                </Col>
              </Form.Group>

            </React.Fragment>
          }

          <Button variant="primary" onClick={handleClick}>Submit</Button>
          {!isLoading ? null : <span>Loading</span>}
          <Button variant="secondary" onClick={props.onCancel}>Cancel</Button>

          <Paystub paystubs={data.paystubs} />
        </Form>

      </Col>

    </Row>
  );
}


function Paystub(props) {

  function formatMoney(num) {
    return num.toFixed(2);
  }

  if (props.paystubs.length === 0) {
    return null;
  }

  const p = props.paystubs[0];

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th></th>
          <th>Pay</th>
          <th>Year</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Gross Pay</td>
          <td>{formatMoney(p.payGross)}</td>
          <td>{formatMoney(p.yearGross)}</td>
        </tr>
        <tr>
          <td>CPP</td>
          <td>{formatMoney(p.payCPP)}</td>
          <td>{formatMoney(p.yearCPP)}</td>
        </tr>
        <tr>
          <td>EI</td>
          <td>{formatMoney(p.payEI)}</td>
          <td>{formatMoney(p.yearEI)}</td>
        </tr>
        <tr>
          <td>Federal Tax</td>
          <td>{formatMoney(p.payFederal)}</td>
          <td>{formatMoney(p.yearFederal)}</td>
        </tr>
        <tr>
          <td>Provincial Tax</td>
          <td>{formatMoney(p.payProvincial)}</td>
          <td>{formatMoney(p.yearProvincial)}</td>
        </tr>
        <tr>
          <td>Net Pay</td>
          <td>{formatMoney(p.payNet)}</td>
          <td>{formatMoney(p.yearNet)}</td>
        </tr>
      </tbody>
    </Table>
  );
}


